import React from 'react';
import { breakpointsWidth, slidesBreakpoints } from './constants';

/**
 * DidMount like hook effect
 *
 * @export
 * @param {*} contentListID
 * @param {*} getContentListHandler
 */
export function useDidMount(contentListID, getContentListHandler, isLoading) {

  React.useEffect(() => {
    if (contentListID && getContentListHandler && !isLoading) {
      getContentListHandler(contentListID);
    }
  }, []);
}

/**
 * Hooks effect to return width on resize window.
 *
 * @export
 * @returns
 */
 export function useResize() {
  const [width, setWidth] = React.useState(window.innerWidth);
  const handleResize = React.useCallback(
    (e) => setWidth(window.innerWidth),
    []
  );

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return {
    width
  };
}


/**
 * Return slidePerViewCount based on imageMode and width
 *
 * @export
 * @param {*} imageMode
 */
 export function useSlidePerViewCount(imageMode) {
  const { width } = useResize();
  const [slidePerViewCount, setSlidePerViewCount] = React.useState(0);

  React.useEffect(() => {
    
    if(width >= breakpointsWidth.desktop){
      setSlidePerViewCount(slidesBreakpoints[imageMode][breakpointsWidth.desktop]);
    }
    else if(width >= breakpointsWidth.tab_port){
      setSlidePerViewCount(slidesBreakpoints[imageMode][breakpointsWidth.tab_port]);
    }
    else if(width >= breakpointsWidth.tab_medium){
      setSlidePerViewCount(slidesBreakpoints[imageMode][breakpointsWidth.tab_medium]);
    }
    else if(width >= breakpointsWidth.phone){
      setSlidePerViewCount(slidesBreakpoints[imageMode][breakpointsWidth.phone]);
    }

  }, [width]);

  return { slidePerViewCount }
}
